import React from 'react';

import { SidebarAccountsQuery } from './graphql/query.sidebarAccounts.generated';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { NavLink, navLinkStyles } from '../nav-link/NavLink';

type Envelope = SidebarAccountsQuery['envelopes'][number];
type Props = { envelope: Envelope };

export const EnvelopeItem: React.FC<Props> = ({ envelope }) => {
  const accountUrls = envelope.accounts.map(account => {
    return account.__typename === 'CheckingAccount'
      ? account.remote && urlBuilder.getAppCheckingSummary({ accountId: account.remote.checkingAccountId })
      : urlBuilder.appAccount({ accountId: account.id });
  });

  if (!envelope.purpose) return null;

  const purposeId = envelope.purpose.id;

  return (
    <NavLink
      key={envelope.id}
      className={navLinkStyles({ spacing: 'expanded' })}
      to={urlBuilder.appPurpose({ purposeId })}
      activeWhen={loc => {
        if (accountUrls.includes(loc.pathname)) return true;

        const isAccountPerformancePage = /^\/account\/.+\/performance$/.test(loc.pathname);
        const returnTo = new URLSearchParams(loc.search).get('returnTo');
        return isAccountPerformancePage && returnTo === urlBuilder.appPurpose.absolute({ purposeId });
      }}
    >
      <NavLink.Icon asChild={true}>
        <img src={envelope.purpose.image.dark} alt="" />
      </NavLink.Icon>
      <NavLink.Text>{envelope.purpose.name}</NavLink.Text>
    </NavLink>
  );
};
